export const FragmentBuyerSubscriptionsItem = new TypedDocumentString(`
    fragment BuyerSubscriptionsItem on BuyerSubscriptionsItem {
  id
  newsletter
  reviewRemindersEnabled
  __typename
}
    `, {"fragmentName":"BuyerSubscriptionsItem"});